// Copyright 2017 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { GenericMeasurement } from "datatypes/SoramaWebApi";
import { DelegateFilter, IFilter } from "filters/IFilter";

@autoinject
export class GenericMeasurementFilterFactory {
    public create(filterFunction: (setups: GenericMeasurement) => boolean): IFilter<GenericMeasurement> {
        return new DelegateFilter<GenericMeasurement>((item) => Promise.resolve(filterFunction(item)));
    }
}
